import React, { useEffect, useState } from "react";
import { Container, Typography, Grid, Box } from "@mui/material";
import HomeCard from "../Component/HomeCard/HomeCard";
import VideoCorousel from "../Component/VideoCorousel/VideoCorousel";
import axios from "axios";
import HomeCard2 from "../Component/HomeCard/Homecard2";

export default function Interior() {
  const [Interior, setInterior] = useState([]);

  useEffect(() => {
    const fetchInterior = async () => {
      try {
        const response = await axios.get(
          `https://urbancasabackendfiles.onrender.com/api/innerProjects?category=Interior`
        );
        setInterior(response.data);
      } catch (error) {
        console.error("Error fetching custom homes:", error);
      }
    };

    fetchInterior();
  }, []);

  return (
    <div>
      <VideoCorousel />
      <Container maxWidth="80%" style={{ padding: "40px" }}>
        <Typography variant="h3" align="center" gutterBottom>
          Interior Designs
        </Typography>

        <Box display="flex" justifyContent="center" flexWrap="wrap" gap="2vw">
          {Interior.map((home) => (
            <Box key={home._id} sx={{ width: { xs: "100%", sm: "45%", md: "30%" } }}>
              {/* <HomeCard home={home} /> */}
              <HomeCard2 home={home} />
            </Box>
          ))}
        </Box>
      </Container>
    </div>
  );
}
